import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mb-5",
  style: {"background-color":"var(--color-light-light-gray)","padding":"20px"}
}
const _hoisted_2 = { class: "h5 fw-bold mb-3" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t(
          `project.previewAndReport.reportTypes.${_ctx.reportType}.installation.title`
        )), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t(
              `project.previewAndReport.reportTypes.${_ctx.reportType}.installation.description`
            )), 1)
      ])
    ])
  ]))
}